import React from "react";
import Button from "../Button";

const ProceedPaymentBottomSheet: React.FC<{
  finalAmountToPay: number;
  handleProceedToPayment: () => void;
  termsAccepted: boolean | null;
  isLoading: boolean;
}> = ({
  finalAmountToPay,
  handleProceedToPayment,
  termsAccepted,
  isLoading,
}) => {
  return (
    <>
      {/* Bottom Fixed Sheet */}
      <div className="fixed rounded-t-lg max-w-lg mx-auto w-full min-h-20 bg-white bottom-0 left-0 right-0 z-10 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] bg-black/50">
        <div className="flex justify-between items-center p-4">
          <div>
            <p className="text-sm text-gray-700">Total Payable</p>
            <p className="text-lg font-semibold text-black">
              ₹ {finalAmountToPay || 0}
            </p>
          </div>
          <Button
            size="md"
            rounded="full"
            variant="contained"
            onClick={() => {
              handleProceedToPayment();
            }}
            disabled={termsAccepted === false}
            loading={isLoading}
          >
            Proceed to Payment
          </Button>
        </div>
      </div>
    </>
  );
};

export default ProceedPaymentBottomSheet;
